export const formatUtcDate = (expectedDate: number | undefined) =>
  expectedDate &&
  new Date(expectedDate * 1000).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
